import React, { useEffect, useState, useRef } from 'react';
import { FormattedMessage, useIntl } from "react-intl";
import API from '../../../utils/API';
import RadioCheck from '../../../components/MessageManager/RadioCheck';
import CheckboxBtn from '../../../components/SignagePlus/CheckboxBtn';
import commonFunctions from '../../../utils/commonFunctions';
import InputValidation from '../../../utils/InputValidation';
import { SIGNAGE_MEDIA } from '../../../utils/constants';
import { use } from 'react';

function AddLink({
  refreshData,
  setSuccess,
  closeModal,
  linkItem,
  setLinkItem,
  updatePlaylistsMedia
}) {
  const [name, setName] = useState('');
  const [link, setLink] = useState('');
  const [embedCode, setEmbedCode] = useState('');
  const [mode, setMode] = useState(SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK);
  const [type, setType] = useState(SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK);
  const [audio, setAudio] = useState(true);
  const [nameValid, setNameValid] = useState('');
  const [linkValid, setLinkValid] = useState('');
  const [embedCodeValid, setEmbedCodeValid] = useState('');
  const [slideDuration, setSlideDuration] = useState('');
  const [slideDurationValid, setSlideDurationValid] = useState('');
  const [googleSlidesTotal, setGoogleSlidesTotal] = useState('');
  const [googleSlidesTotalValid, setGoogleSlidesTotalValid] = useState('');
  const [modalError, setModalError] = useState('');
  const modalBodyRef = useRef(null);
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [typeLinkOptions] = useState({ 
    [SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK]: "WEBSITE", 
    [SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_YOUTUBE]: "YOUTUBE", 
    [SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_VIMEO]: "VIMEO",
    [SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_MP4]: "VIDEO",
    [SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_GOOGLE_SLIDES]: "GOOGLE_SLIDES"
   });
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  /**
    * Reset modal
    */
  function resetModal() {
    setSubmitted(false);
    setModalError('');
    setName('');
    setLink('');
    setEmbedCode('');
    setMode(SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK);
    setType(SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK);
    setAudio(true);
    setNameValid('');
    setLinkValid('');
    setEmbedCodeValid('');
    setLinkItem(null);
    setSlideDuration('');
    setSlideDurationValid('');
    setGoogleSlidesTotal('');
    setGoogleSlidesTotalValid('');
  }

  useEffect(() => {
    if (linkItem) {
      setName(linkItem.name);
      setLink(linkItem.content?.urls?.[0] || '');
      setEmbedCode(linkItem.content?.embedCode || '');
      setMode(linkItem.subcategory || SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK);
      let tempType = linkItem.type || SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK;
      setType(tempType);
      if(linkItem.content?.urls?.[0]){
        setAudioTypeFromUrl(tempType, linkItem.content?.urls?.[0] || '');
      }
      if(linkItem.subcategory === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK && linkItem.type === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_GOOGLE_SLIDES){
        if(linkItem.content?.slideDuration){
          setSlideDuration(linkItem.content?.slideDuration || '');
        }else{
          setSlideDurationFromLink(linkItem.content?.urls?.[0]);
        }
        setGoogleSlidesTotal(linkItem.content?.slidesTotal || '');
      }
    }
  }, [linkItem]);

  useEffect(() => {
    const modalElement = document.getElementById('addLinkModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', resetModal);
    };
  }, []);

  useEffect(() => {
    if (mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE) {
      setType(SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE);
    } else if (mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK) {
      let tempType = linkItem?.type && linkItem?.type !== SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE ? linkItem?.type : SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK;
      setType(tempType);
      if(linkItem?.content?.urls?.[0]){
        setAudioTypeFromUrl(tempType, linkItem?.content?.urls?.[0] || '');
      }
    }
  }, [mode]);

  const validateField = (value, field) => {
    if (InputValidation.validateEmpty(value)) return 'EMPTY_FIELD_ERROR';

    if (field === 'name' && (value.length < 2 || value.length > 36)) return 'LINK_NAME_LENGTH';

    if (field === 'link') {
      let urlObj = null;
      try {
        urlObj = new URL(value);
      } catch (e) {
        urlObj = null;
      }

      switch (type) {
        case SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_YOUTUBE:
          if (!urlObj || !isYouTubeUrl(urlObj)) return 'LINK_TYPE_MATCH';
          break;
        case SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_VIMEO:
          if (!urlObj || !isVimeoUrl(urlObj)) return 'LINK_TYPE_MATCH';
          break;
        case SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_MP4:
          const supportedFormats = ['.mp4', '.mov', '.avi', '.mkv', '.flv'];
          if (!urlObj || !supportedFormats.some(format => urlObj.pathname.toLowerCase().endsWith(format))) return 'LINK_TYPE_MATCH';
          break;
        case SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_GOOGLE_SLIDES:
        {
          if (!urlObj || !isGoogleSlidesUrl(urlObj)) return 'LINK_TYPE_MATCH';
        }
          break;
      }
    }
    return '';
  };

  const handleChangeName = (e) => {
    const value = e.target.value/*.trim()*/;
    setName(value);
    setNameValid(validateField(value, 'name'));
  };

  const handleChangeLink = (e) => {
    const value = e.target.value/*.trim()*/;
    setLink(value);
    setLinkValid(validateField(value, 'link'));
    if( mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK && 
      type === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_GOOGLE_SLIDES &&
      linkValid.length == 0 && 
      slideDuration.length == 0 ){
      setSlideDurationFromLink(value);
    }
  };

  const handleChangeEmbedCode = (e) => {
    const value = e.target.value/*.trim()*/;
    setEmbedCode(value);
    setEmbedCodeValid(validateField(value));
  };

  const handleChangeSlideDuration = (e) => {
    const value = e.target.value/*.trim()*/;
    setSlideDuration(value);
    setSlideDurationValid(InputValidation.validateOnlyNumber(value));
  };

  const handleChangeGoogleSlidesTotal = (e) => {
    const value = e.target.value/*.trim()*/;
    setGoogleSlidesTotal(value);
    setGoogleSlidesTotalValid(InputValidation.validateOnlyNumber(value));
  };

  const isYouTubeUrl = (urlObj) => {
    try {
      return ['youtube.com', 'www.youtube.com', 'youtu.be'].includes(urlObj.hostname);
    } catch (e) {
      console.log(`******errror=${e}`);
      return false; // Not youtube URL
    }
  };
  const isVimeoUrl = (urlObj) => {
    try {
      return ['vimeo.com', 'www.vimeo.com', 'player.vimeo.com'].includes(urlObj.hostname);
    } catch (e) {
      console.log(`******errror=${e}`);
      return false; // Not vimeo URL
    }
  };
  const isGoogleSlidesUrl = (urlObj) => {
    try {
      return ['docs.google.com'].includes(urlObj.hostname) && urlObj.pathname.includes('/presentation/');
    } catch (e) {
      console.log(`******errror=${e}`);
      return false; // Not Google Slides URL
    }
  }
  const setVideoParams = (embedUrl, isVimeoUrl = false) => {
      //Add autoplay and controls parameters
      /**
       * Mei --- 20251229: commented out the code to change the autoplay and controls param
       * Becuase now FW Side don't use these two params any more
       */
      if (!embedUrl.searchParams.has('autoplay')) {
        embedUrl.searchParams.set('autoplay', '1');
      }
      //add controls parameter if not present
      if (!embedUrl.searchParams.has('controls')) {
        embedUrl.searchParams.set('controls', '0');
      }

      //add mute parameter if not present
      /**
       * Mei --- 20251229: commented out the code to change the mute param
       * Becuase now FW Side already support auto play for mute/unmute
       * */
      /*
      if (!embedUrl.searchParams.has('mute')) {
        embedUrl.searchParams.set('mute', '1');
      }
      */
      if(isVimeoUrl){
        if (embedUrl.searchParams.has('mute')) {
          embedUrl.searchParams.delete('mute');
        }
      }

      //set audio state based on mute param
      const searchMuteParam = isVimeoUrl ? "muted" : "mute";
      embedUrl.searchParams.set(searchMuteParam, audio ? '0' : '1');
  };
  const convertYoutubeToEmbedUrl = (urlObj) => {
     try {  
      if (urlObj.pathname.startsWith('/embed/')){
        setVideoParams(urlObj);
        return urlObj.toString();
      }
      let videoId = '';
      if (urlObj.hostname === 'youtu.be') {
        // https://youtu.be/VIDEO_ID
        videoId = urlObj.pathname.slice(1);
      } else {
        // https://www.youtube.com/watch?v=VIDEO_ID
        videoId = urlObj.searchParams.get('v') || 
                urlObj.pathname.split('/').pop();
      }      
      if (!videoId || videoId.length !== 11) return null; // YouTube video ID should be 11 characters long

      //create new embed URL
      const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
      
      // keep original query parameters except 'v'
      urlObj.searchParams.forEach((value, key) => {
        if (key === 't') {
          embedUrl.searchParams.set('start', value);
        } 
        //exclude 'v' parameter from the embed URL
        else if (key !== 'v') {
          embedUrl.searchParams.set(key, value);
        }
      });
      
      // Handling timestamps in hashes (for example #t=1m30s)
      if (urlObj.hash) {
          const hashMatch = urlObj.hash.match(/t=(\d+m)?(\d+s)?/);
          if (hashMatch) {
            const minutes = hashMatch[1] ? parseInt(hashMatch[1]) : 0;
            const seconds = hashMatch[2] ? parseInt(hashMatch[2]) : 0;
            embedUrl.searchParams.set('start', minutes * 60 + seconds);
          }
      }
      setVideoParams(embedUrl);
      return embedUrl.toString();
    } catch (e) {
      return null;
    }
  };
  const convertVimeoToEmbedUrl = (urlObj) => {
    try {
      if (urlObj.href.includes('player.vimeo.com/video/') && urlObj.hostname.includes('player.vimeo.com')) {
        console.log(`Already an embed URL: ${urlObj.href}`);
        setVideoParams(urlObj, true);
        return urlObj.toString();
      }
      let videoId = '';

      //https://vimeo.com/VIDEO_ID?fl=wc
      //https://vimeo.com/VIDEO_ID?share=copy#t=36.691
      videoId = urlObj.pathname.split('/').pop();    
      if (!videoId) return null;

      //create new embed URL
      const embedUrl = new URL(`https://player.vimeo.com/video/${videoId}`);
      
      // keep original query parameters except 'v'
      urlObj.searchParams.forEach((value, key) => {
        if (key === 't') {
          embedUrl.searchParams.set('start', value);
        }
        else {
          embedUrl.searchParams.set(key, value);
        }
      });

      setVideoParams(embedUrl, true);
      // Handling timestamps in hashes (for example #t=1m30s)
      if (urlObj.hash) {
        /*const hashMatch = urlObj.hash.match(/#t=(\d+m)?(\d+s)?/);
        if (hashMatch) {
          if(hashMatch[1] || hashMatch[2]){
            const minutes = hashMatch[1] ? parseInt(hashMatch[1]) : 0;
            const seconds = hashMatch[2] ? parseInt(hashMatch[2]) : 0;
            embedUrl.searchParams.set('#start', minutes * 60 + seconds);
          }else{
            embedUrl.searchParams.set('#start', urlObj.hash.slice(3)); // Remove the '#t=' character
          }
        }*/
        if(urlObj.hash.startsWith('#t=')){
          return embedUrl.toString() + urlObj.hash; // Append the original hash to the embed URL
        }
      }
      return embedUrl.toString();
    } catch (e) {
      return null;
    }
  };
  const convertGoogleSlidesToEmbedUrl = (urlObj) => {
    try{
      /*
       * For Google Slides, we can convert the URL to an embed URL format
       *Example: https://docs.google.com/presentation/d/SLIDE_ID/edit -> https://docs.google.com/presentation/d/SLIDE_ID/embed
       *https://docs.google.com/presentation/d/e/SLIDE_ID/pubembed?start=true&loop=true&delayms=10000
      */
      const pathParts = urlObj.pathname.split('/');
      console.log('Path parts:', pathParts);

      let presentationId = null;
      //create new embed URL
      let embedUrl = null;
      if(pathParts.length > 3 && pathParts[1] === 'presentation' && pathParts[2] === 'd') {
        if(pathParts[3] === 'e'){
          presentationId = pathParts[4];
          embedUrl = new URL(`https://docs.google.com/presentation/d/e/${presentationId}/pubembed`);
        }else{
          presentationId = pathParts[3];
          embedUrl = new URL(`https://docs.google.com/presentation/d/${presentationId}/embed`);
        }
      }
      urlObj.searchParams.forEach((value, key) => {
        embedUrl.searchParams.set(key, value);
      });

      if (!embedUrl.searchParams.has('start') || 
          embedUrl.searchParams.get('start') === 'false' ||
          embedUrl.searchParams.get('start') === false) {
            
        embedUrl.searchParams.set('start', true);
      }
      if (!embedUrl.searchParams.has('loop') || 
          embedUrl.searchParams.get('loop') === 'false' || 
          embedUrl.searchParams.get('loop') === false) {

        embedUrl.searchParams.set('loop', true);
      }
      if (!embedUrl.searchParams.has('delayms')) {
        embedUrl.searchParams.set('delayms', 10000);
      }

      //set user defined delayms if provided
      if(slideDuration && slideDuration !== '' && !isNaN(slideDuration) && Number(slideDuration) > 0){
        embedUrl.searchParams.set('delayms', Math.ceil(Number(slideDuration) * 1000));
      }
      return {embedUrl: embedUrl.toString(), presentationId};
    } catch (e) {
      console.log(`****convertGoogleSlidesToEmbedUrl**errror=${e.message}`);
      return null;
    }
  }

    const setSlideDurationFromLink = (googleSlidesLink) => {
        try {
            if (!googleSlidesLink || googleSlidesLink.trim() === '') {
                return;
            }
            const urlObj = new URL(googleSlidesLink);
            const delayms = urlObj.searchParams.get('delayms');
            if (delayms && delayms.trim() !== '' && Number(delayms) > 0) {
                const delaymsLink = String(Math.ceil(Number(delayms) / 1000)); //return in seconds
                setSlideDuration(delaymsLink);
                setSlideDurationValid(InputValidation.validateOnlyNumber(delaymsLink));
            }
        } catch (e) {
            console.log(`****setSlideDurationFromLink**errror=${e.message}`);
        }
  }

  const setAudioTypeFromUrl = (typeParam, urlParam) => {
    if((typeParam !== SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK) && urlParam){
      const urlObj = new URL(urlParam); 
      const searchMuteParam = (typeParam === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_VIMEO) ? "muted" : "mute";
      const getMuteParam = urlObj.searchParams.get(searchMuteParam);
      if(getMuteParam !== null){
        setAudio(getMuteParam === '0' ? true : false);
      }       
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    setIsLoading(true);
    try {
      const nameError = validateField(name.trim(), 'name');
      const linkError = mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK ? validateField(link.trim(), 'link') : '';
      const embedCodeError = mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE ? validateField(embedCode.trim()) : '';
      const slideDurationError = mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK && type === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_GOOGLE_SLIDES ? InputValidation.validateOnlyNumber(slideDuration) : '';
      const googleSlidesTotalError = mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK && type === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_GOOGLE_SLIDES ? InputValidation.validateOnlyNumber(googleSlidesTotal) : '';

      if (nameError || linkError || embedCodeError || slideDurationError || googleSlidesTotalError) {
        setNameValid(nameError);
        setLinkValid(linkError);
        setEmbedCodeValid(embedCodeError);
        setSlideDurationValid(slideDurationError);
        setGoogleSlidesTotalValid(googleSlidesTotalError);
        setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
        setIsLoading(false);
        return;
      }

      let embedUrl = null;
      if(mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK && link) {
        const urlObj = new URL(link);       
        if (isYouTubeUrl(urlObj)) {
          embedUrl = convertYoutubeToEmbedUrl(urlObj);
        }else if (isVimeoUrl(urlObj)) {
          embedUrl = convertVimeoToEmbedUrl(urlObj);
        }else if (isGoogleSlidesUrl(urlObj)) {
          const googleSlidesResult = convertGoogleSlidesToEmbedUrl(urlObj);
          embedUrl = googleSlidesResult?.embedUrl;
        }else if(type === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_MP4){
          //for video link type
          setVideoParams(urlObj, false);
          embedUrl = urlObj.toString();
        }
        console.log(`link= ${urlObj} embedUrl new link=${embedUrl}`);
      }

      const formData = {
        category: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK,
        subcategory: mode,
        type: type,
        name: name.trim(),
        content: mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK
          ? { urls: embedUrl?.trim() ? [embedUrl.trim()] : [link.trim()] }
          : { embedCode: embedCode.trim() }
      };

      if(mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK && type === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_GOOGLE_SLIDES){
        formData.content.slideDuration = slideDuration.trim();
        formData.content.slidesTotal = googleSlidesTotal.trim();
        formData.duration = googleSlidesTotal.trim() && slideDuration.trim() ? Number(googleSlidesTotal.trim()) * Number(slideDuration.trim()) : null;
      }
      if (linkItem) {
        formData.id = linkItem.id;
        await API.updateMedia(formData);
        updatePlaylistsMedia(formData);
        setSuccess(<FormattedMessage id="EDIT_LINK_SUCCESS" />);
      } else {
        await API.addMedia(formData);
        setSuccess(<FormattedMessage id="ADD_LINK_SUCCESS" />);
      }
      refreshData();
      closeModal("addLinkModal");
    } catch (err) {
      const errorMessageId = linkItem ? "EDIT_LINK_FAILED" : "ADD_LINK_FAILED";
      let message = err?.response?.data?.message;
      message = message? t(message) : err.message;
      setModalError(<FormattedMessage id={errorMessageId} values={{ errorMsg: <b>{message}</b> }} />);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (modalError && modalBodyRef.current) {
      modalBodyRef.current.scrollTop = modalBodyRef.current.scrollHeight;
    }
  }, [modalError]);

  const RenderGoogleSlidesDuration = () => {
    if (mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK && type === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_GOOGLE_SLIDES) {
      return (
        <>
        <hr className='mt-4'/>
        <div className="row mt-4">
          <div className="col-3">
            <label className="font-weight-600 font-size-14">
              <FormattedMessage id="GOOGLE_SLIDES_TOTAL" defaultMessage="Total Playback Time:" />:
            </label>
            <div className="d-flex align-items-center gap-3 mt-2">
              <input
                className={`form-control h-54 bg-baby-blue ${submitted && (googleSlidesTotalValid ? 'is-invalid' : 'is-valid')}`}
                value={googleSlidesTotal}
                onChange={handleChangeGoogleSlidesTotal}
                name="googleSlidesTotalInput"
              />
              <label className="font-size-14"/>        
            </div>
            {commonFunctions.InvalidFeedbackString(googleSlidesTotalValid, 'GOOGLE_SLIDES_TOTAL', `${submitted && (googleSlidesTotalValid ? 'd-block' : '')}`)}
          </div>
          <div className='col-2'/>
          <div className="col-3">
            <label className="font-weight-600 font-size-14">
              <FormattedMessage id="GOOGLE_SLIDE_DURATION" defaultMessage="Slide Duration:" />:
            </label>
            <div className="d-flex align-items-center gap-3  mt-2">
              <input
                className={`form-control h-54 bg-baby-blue ${submitted && (slideDurationValid ? 'is-invalid' : 'is-valid')}`}
                value={slideDuration}
                onChange={handleChangeSlideDuration}
                name="slideDurationInput"
              />
              <label className="font-size-14"><FormattedMessage id="TIME_S" defaultMessage="s" /></label>
            </div>
            {commonFunctions.InvalidFeedbackString(slideDurationValid, 'GOOGLE_SLIDE_DURATION',`${submitted && (slideDurationValid ? 'd-block' : '')}`)}
          </div>
        </div>
        </>
      )
    }
  }

  return (
    <div className='modal modal-mse fade' id='addLinkModal' tabIndex='-1' aria-labelledby='addLinkModalLable' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content'>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'>{linkItem ? <FormattedMessage id='EDIT_LINK' /> : <FormattedMessage id='ADD_LINKS' />}</h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body' ref={modalBodyRef}>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-12">
                  <label htmlFor="addLinkName" className="font-weight-600 font-size-14 mb-2">
                    <FormattedMessage id="LINK_NAME" defaultMessage="Name" />:
                  </label>
                  <input
                    id="addLinkName"
                    className={`form-control h-54 bg-baby-blue ${submitted && (nameValid ? 'is-invalid' : 'is-valid')}`}
                    value={name}
                    onChange={handleChangeName}
                    name="addLinkName"
                    placeholder={intl.formatMessage({ id: "LINK_NAME", defaultMessage: "Name" })}
                  />
                  {commonFunctions.InvalidFeedbackString(nameValid, 'LINK_NAME')}
                </div>
              </div>
              <div className="row">
                <div className="col-12 mt-4">
                  <label className="font-weight-600 font-size-14">
                    <FormattedMessage id="LINK_SELECT" defaultMessage="Select" />:
                  </label>
                  <RadioCheck
                    options={{ [SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK]: "LINK", [SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE]: "LINK_EMBEDDED_CODE" }}
                    name="LINK_SELECT"
                    selectedOption={mode}
                    onChange={e => setMode(e.target.value)}
                  />
                </div>
              </div>
              {mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.LINK && (
                <>
                  <div className="row">
                    <div className="col-12 mt-4">
                      <label className="font-weight-600 font-size-14">
                        <FormattedMessage id="SELECT_TYPE_LINK:" defaultMessage="Select Type Of Link" />:
                      </label>
                      <RadioCheck
                        options={typeLinkOptions}
                        name="SELECT_TYPE_LINK"
                        selectedOption={type}
                        onChange={e => setType(e.target.value)}
                      />
                      <CheckboxBtn
                        name="AUDIO_BTN"
                        selected={audio}
                        disabled={(type === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_LINK || type === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_GOOGLE_SLIDES) ? true : false}
                        onChange={e => { setAudio(e.target.checked); }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="mt-4">
                      <label className="font-weight-600 font-size-14 mb-2">
                        <FormattedMessage id="LINK" defaultMessage="Link" />:
                      </label>
                      <input
                        className={`form-control h-54 bg-baby-blue ${submitted && (linkValid ? 'is-invalid' : 'is-valid')}`}
                        value={link}
                        onChange={handleChangeLink}                        
                        name="addLinkInput"
                        placeholder={intl.formatMessage({ id: "LINK", defaultMessage: "Link" })}
                      />
                      {commonFunctions.InvalidFeedbackString(linkValid, 'LINK')}
                    </div>
                  </div>
                  {RenderGoogleSlidesDuration()}
                </>
              )}
              {mode === SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CODE && (
                <div className="row mt-3">
                  <div className="mb-2 col-12">
                    <textarea
                      className={`form-control h-54 bg-baby-blue ${submitted && (embedCodeValid ? 'is-invalid' : 'is-valid')}`}
                      style={{ height: 104 }}
                      value={embedCode}
                      onChange={handleChangeEmbedCode}
                      name="addEmbedCode"
                      placeholder={intl.formatMessage({ id: "LINK_EMBEDDED_CODE", defaultMessage: "Embedded Code" })}
                    />
                    {commonFunctions.InvalidFeedbackString(embedCodeValid, 'LINK_EMBEDDED_CODE')}
                  </div>
                </div>
              )}
              {submitted && modalError && (
                <div className='modal-error invalid-feedback d-block fw-bold text-center mt-3'>
                  {modalError}
                </div>
              )}
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="backGroupModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="saveGroupBtn" className='btn btn-primary but-darkblue' type='button' onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              ) : null}
              {linkItem ? <FormattedMessage id='EDIT_LINK' /> : <FormattedMessage id='ADD_LINKS' />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddLink;